module.exports = __webpack_public_path__ + "static/media/A2.32184c8e.png";